import React from 'react';
import { AvTooltip, Filter } from '@fabric-ui/components';
import { CaseSensitive } from '@fabric-ui/icons';
import { ToggleButton } from '@mui/material';

interface Props {
  actualFilterValue: Filter;
  filter: Filter;
  setFilter: any;
}

export function CaseSensitiveButton({ actualFilterValue, filter, setFilter }: Props) {
  return (
    <AvTooltip title={`Case Sensitive ${actualFilterValue.expression!.caseInsensitive ? 'OFF' : 'ON'}`}>
      <ToggleButton
        value="case_sensitive"
        selected={!actualFilterValue.expression!.caseInsensitive}
        onChange={() =>
          setFilter({ ...filter, expression: { ...filter.expression, caseInsensitive: !filter.expression!.caseInsensitive } })
        }
        sx={({ palette }) => ({
          border: `1px solid ${palette.colors.neutrals[400]}`,
          padding: '5px',
          '&.Mui-selected, &.Mui-selected:hover': {
            backgroundColor: palette.colors.primary[150],
            borderColor: palette.colors.primary[500],
          },
        })}>
        <CaseSensitive />
      </ToggleButton>
    </AvTooltip>
  );
}
